/* DRINK MILK: collection page — size filter, sort and word filter (e.g. SETS) with cards gliding to their places,
   the drifting title word, and quick add. Ported from the prototype (wedding-site/src/collection.js).
   Cards come from Liquid; their data-* attributes hold title, price, stock and available sizes. */
(function () {
  const shop = document.querySelector('.dm-shop');
  if (!shop) return;
  const gsap = window.gsap;
  const { ScrollTrigger, Flip } = window;
  gsap.registerPlugin(ScrollTrigger, Flip);
  const { savedSize } = window.DMFit;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  const grid = $('.shop-grid', shop);
  const cards = $$('.card', grid);
  const sizesEl = $('.shop-sizes', shop);
  const fit = savedSize();
  const state = { size: null, sort: '', filter: new URLSearchParams(location.search).get('filter') || '' };

  /* ---------- Which cards show, in which order ---------- */

  function visible() {
    let list = [...cards];
    if (state.filter) {
      const word = new RegExp(`\\b${state.filter.replace(/[^\w]/g, '')}\\b`, 'i');
      list = list.filter((c) => word.test(c.dataset.title));
    }
    if (state.size) list = list.filter((c) => c.dataset.sizes.split(' ').includes(state.size));
    if (state.sort === 'low') list.sort((a, b) => a.dataset.price - b.dataset.price);
    else if (state.sort === 'high') list.sort((a, b) => b.dataset.price - a.dataset.price);
    // Sold-out pieces go last so the first screen is all buyable
    const inStock = (c) => c.dataset.available === 'true';
    return [...list.filter(inStock), ...list.filter((c) => !inStock(c))];
  }

  /* ---------- Header of the page: title, count, tabs, sizes ---------- */

  // A word-filter tab (like Sets) is shown on the "all" page itself
  const filterTab = state.filter && $$('.shop-tab', shop).find((t) => t.dataset.filter.toLowerCase() === state.filter.toLowerCase());
  if (filterTab) {
    $$('.shop-tab', shop).forEach((t) => {
      t.classList.toggle('is-active', t === filterTab);
      if (t === filterTab) t.setAttribute('aria-current', 'page');
      else t.removeAttribute('aria-current');
    });
    const word = filterTab.dataset.word || filterTab.textContent.trim().toUpperCase();
    $('.shop-hero__title', shop).textContent = filterTab.textContent.trim();
    $('.shop-hero__marquee span', shop).textContent = `${word} ✦ `.repeat(8);
    document.title = document.title.replace(/^[^|–-]+/, `${filterTab.textContent.trim()} `);
  }
  $('.shop-tab.is-active', shop)?.scrollIntoView({ block: 'nearest', inline: 'center' });

  let countFlicker = 0;
  function showCount(n) {
    const el = $('.shop-hero__num', shop);
    const final = String(n).padStart(2, '0');
    clearInterval(countFlicker);
    if (reducedMotion()) return (el.textContent = final);
    let ticks = 0;
    // Flickers through a few values before settling, like the drop counter on the homepage
    countFlicker = setInterval(() => {
      ticks += 1;
      el.textContent = ticks > 6 ? final : String(Math.floor(Math.random() * 40)).padStart(2, '0');
      if (ticks > 6) clearInterval(countFlicker);
    }, 45);
  }

  function paintSizes() {
    $$('button', sizesEl).forEach((b) => {
      b.setAttribute('aria-pressed', String(b.dataset.size === state.size));
      b.classList.toggle('is-fit', !state.size && b.dataset.size === fit);
    });
  }

  /* ---------- Rendering, with cards gliding to their new places ---------- */

  let entered = false;
  function render({ animate } = {}) {
    const list = visible();
    const flip = animate && !reducedMotion() ? Flip.getState($$('.card', grid)) : null;
    if (animate) {
      entered = true;
      gsap.set($$('.card', grid), { clearProps: 'opacity,transform' });
    }
    grid.replaceChildren(...list);
    // The size picked in the filter (or found by the size calculator) is outlined on every card
    const mark = state.size || fit;
    $$('.size-chip', grid).forEach((c) => c.classList.toggle('is-fit', c.textContent.trim() === mark));
    $('.shop-empty', shop).hidden = list.length > 0;
    showCount(list.length);
    if (flip) {
      Flip.from(flip, {
        duration: 0.6,
        ease: 'power3.inOut',
        absolute: true,
        stagger: 0.02,
        onEnter: (els) => gsap.fromTo(els, { opacity: 0, scale: 0.9, y: 30 }, { opacity: 1, scale: 1, y: 0, duration: 0.5, delay: 0.15, stagger: 0.03 }),
        onLeave: (els) => gsap.to(els, { opacity: 0, scale: 0.9, duration: 0.3 }),
      });
    }
  }

  sizesEl.addEventListener('click', (e) => {
    const b = e.target.closest('button');
    if (!b) return;
    state.size = state.size === b.dataset.size ? null : b.dataset.size;
    paintSizes();
    render({ animate: true });
  });
  $('.shop-empty__clear', shop).addEventListener('click', () => {
    state.size = null;
    paintSizes();
    render({ animate: true });
  });
  $('.shop-sort select', shop).addEventListener('change', (e) => {
    state.sort = e.target.value;
    render({ animate: true });
  });

  // A size chip on a card puts the piece in the side cart
  grid.addEventListener('click', (e) => {
    const chip = e.target.closest('button.size-chip');
    if (!chip) return;
    chip.classList.add('is-added');
    setTimeout(() => chip.classList.remove('is-added'), 1200);
    window.DMCart?.add(+chip.dataset.id, { from: chip.closest('.card').querySelector('.card__media img') });
  });

  paintSizes();
  render();

  /* ---------- Motion ---------- */

  const shell = window.DMShell;
  const mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: no-preference)', () => {
    const lenis = new window.Lenis({ autoRaf: false });
    lenis.on('scroll', ScrollTrigger.update);
    shell?.setLenis(lenis);
    const raf = (t) => lenis.raf(t * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);

    // Title: the giant word slides in and keeps drifting; scrolling pushes it faster
    gsap.from('.dm-shop .shop-hero__title', { y: 40, opacity: 0, duration: 1, ease: 'power4.out', delay: 0.1 });
    gsap.from('.dm-shop .shop-hero__count', { y: 20, opacity: 0, duration: 0.8, ease: 'power3.out', delay: 0.25 });
    const drift = gsap.fromTo('.dm-shop .shop-hero__marquee span', { xPercent: 0 }, { xPercent: -50, duration: 40, ease: 'none', repeat: -1 });
    gsap.from('.dm-shop .shop-hero__marquee', { xPercent: 12, opacity: 0, duration: 1.4, ease: 'power3.out' });
    ScrollTrigger.create({
      onUpdate: (self) => gsap.to(drift, { timeScale: 1 + Math.min(Math.abs(self.getVelocity()) / 150, 8), duration: 0.2, overwrite: true, onComplete: () => gsap.to(drift, { timeScale: 1, duration: 0.8 }) }),
    });

    // Cards rise in a row at a time as they scroll into view
    gsap.set('.dm-shop .shop-grid .card', { opacity: 0, y: 60 });
    ScrollTrigger.batch('.dm-shop .shop-grid .card', {
      start: 'top 92%',
      once: true,
      onEnter: (batch) => {
        if (entered) return;
        gsap.to(batch, { opacity: 1, y: 0, duration: 0.9, stagger: 0.08, ease: 'power3.out' });
      },
    });

    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      shell?.setLenis(null);
    };
  });

  addEventListener('load', () => ScrollTrigger.refresh());
})();
